
import React from "react";
import CookieConsent from "react-cookie-consent";
import "./CookieConsentBanner.css";

const CookieConsentBanner = ({ setConsent }) => {
  const handleAccept = () => {
    setConsent(true);
    console.log("Cookies accepted");
    window.location.reload(); // Seite neu laden

  };

  const handleDecline = () => {
    setConsent(false);
    console.log("Cookies declined");
  };

  return (
    <div className="cookie-consent-backdrop">
      <CookieConsent
        location="none"
        buttonText="Akzeptieren"
        declineButtonText="Ablehnen"
        cookieName="vorpoint-cookie-consent"
        disableStyles
        containerClasses="cookie-consent-container"
        buttonClasses="cookie-consent-button"
        declineButtonClasses="cookie-consent-decline-button"
        contentClasses="cookie-consent-content"
        expires={150}
        enableDeclineButton
        onAccept={handleAccept}
        onDecline={handleDecline}
      >
        <h3>Cookie-Einstellungen</h3>
        <p>
          Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern.
          Bitte wählen Sie Ihre Präferenzen.
        </p>
      </CookieConsent>
    </div>
  );
};

export default CookieConsentBanner;
